<template>
  <div class="reminder-section" :data-qid="qid">
    <div class="reminder-section__header">
      <h6 class="mb-0">{{ title }}</h6>
      <span class="reminder-section__due" v-if="dueDate">
        <font-awesome-icon icon="calendar-alt" class="mr-1"/>{{ $t('projects.reminders.due_date', { date: $options.filters.formatDate(dueDate, 'DD MMM YYYY', true) }) }}
      </span>
    </div>

    <table class="table table-responsive-md mb-0">
      <thead>
        <tr>
          <th>{{ $t('projects.table.name') }}</th>
          <th class="text-center" width="110">{{ $t('table.progress') }}</th>
          <th width="35%"></th>
          <th width="190"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="qid + '-' + row.user.id">
          <td class="text-truncate">
            <span class="user-tag">
              <Avatar :object="row.user" size="xs"></Avatar>
              <span class="ml-2">{{ row.user.name }}</span>
            </span>
          </td>
          <td class="text-center" style="line-height: 22px;">
            <div>{{ progress(row) }}%</div>
            <div class="text-muted">{{ row.completed_tasks }} / {{ row.tasks }}</div>
          </td>
          <td class="align-middle">
            <b-progress :value="progress(row)"
                        :max="100"
                        :variant="variant(row)"
                        :class="variant(row)"
            ></b-progress>
          </td>
          <td class="align-middle">
            <b-button v-if="canSend && progress(row) < 100"
                      class="float-right"
                      variant="light"
                      @click="$emit('send', row.user)"
                      :data-qid="qid + '-send-' + row.user.id"
            >
              {{ $t('tasks.send_reminder') }}
            </b-button>
          </td>
        </tr>
        <tr v-if="!rows.length">
          <td colspan="4" class="text-center text-muted">{{ $t('projects.reminders.no_assignees') }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue';

// Assignees of one kind of task with their progress and a reminder button
export default {
  name: 'ReminderAssigneesTable',
  props: {
    title: String,
    rows: {
      type: Array,
      default: () => []
    },
    dueDate: {},
    canSend: Boolean,
    qid: String
  },
  components: {
    Avatar
  },
  methods: {
    progress(row) {
      return row.tasks ? Math.round(row.completed_tasks / row.tasks * 100) : 0;
    },
    variant(row) {
      if (this.progress(row) === 100) {
        return 'success';
      }
      return this.dueDate && new Date(this.dueDate) < new Date() ? 'danger' : 'info';
    }
  }
}
</script>
